export const shippingPartners = [
  {
    id: 'fedex',
    image: {
      src: '/images/logos/shipping_partners/fedex_logo.svg',
      alt: 'FedEx logo'
    },
    links: [
      { title: 'Fedex.com Home Page', href: 'https://www.fedex.com/en-us/home.html' },
      { title: 'Fedex.com Home Services', href: 'https://www.fedex.com/en-us/shipping.html' },
      { title: 'Fedex.com Home Terms Of Use', href: 'https://www.fedex.com/en-us/terms-of-use.html' }
    ]
  },
  {
    id: 'dhl',
    image: {
      src: '/images/logos/shipping_partners/dhl_logo.svg',
      alt: 'DHL logo'
    },
    links: [
      { title: 'DHL.com Home Page', href: 'https://www.dhl.com/us-en/home.html' },
      { title: 'DHL.com Home Services', href: 'https://www.dhl.com/us-en/home/dhl-for-business.html' },
      { title: 'DHL.com Home Terms Of Use', href: 'https://www.dhl.com/us-en/home/footer/terms-of-use.html' }
    ]
  },
  {
    id: 'ups',
    image: {
      src: '/images/logos/shipping_partners/ups_logo.svg',
      alt: 'UPS logo'
    },
    links: [
      { title: 'UPS.com Home Page', href: 'https://www.ups.com/us/en/Home.page' },
      {
        title: 'UPS.com Home Services',
        href: 'https://www.ups.com/us/en/business-solutions/business-shipping-tools.page'
      },
      {
        title: 'UPS.com Home Terms Of Use',
        href: 'https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions/website-terms-of-use.page'
      }
    ]
  }
]
